import { render, staticRenderFns } from "./productItem.vue?vue&type=template&id=153193a2&scoped=true&"
import script from "./productItem.vue?vue&type=script&lang=js&"
export * from "./productItem.vue?vue&type=script&lang=js&"
import style0 from "./productItem.vue?vue&type=style&index=0&id=153193a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153193a2",
  null
  
)

export default component.exports